import React from 'react';
import { withRouter } from 'react-router-dom';

import AuthUserContext from './auth_user_context';
import { auth } from '../firebase/firebase';
import { defaultRoute } from './default-route';
import { connect } from 'react-redux';
import {
  fetchMysubscriptions,
  getUser,
  updateIsFirstLogin
} from '../redux/actions/user-actions';
import { checkUserSubscription } from '../utils/checkSubscription';

const withAuthorization = (authCondition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      this.listener = auth.onAuthStateChanged(async (authUser) => {
        if (authUser) {
          try {
            const idTokenResult = await authUser.getIdTokenResult();
            const token = await authUser.getIdToken();
            const currentPath = this.props.history.location.pathname;

            authUser.userStatus = idTokenResult.claims.userStatus;
            authUser.subscriptionType = idTokenResult.claims.subscriptionType;
            authUser.isAdmin = idTokenResult.claims.isAdmin;

            const isFirstLogin =
              localStorage.getItem('infloFirstLogin') !== null;
            await this.props.dispatch(updateIsFirstLogin(isFirstLogin));

            if (
              !this.props.mysubscriptions ||
              Object.keys(this.props.mysubscriptions).length === 0
            ) {
              await this.props.dispatch(fetchMysubscriptions(token));
            }

            if (
              !this.props.podcastUser ||
              Object.keys(this.props.podcastUser).length === 0
            ) {
              await this.props.dispatch(getUser(token));
            }

            const isPersonalPodcastOwner = this.props.podcastUser?.isOwner;

            const isSubscriptionActive = checkUserSubscription(
              this.props.mysubscriptions,
              this.props.podcastUser?.endDateTrialTime
            );

            if (
              this.props.isFirstLogin &&
              this.props.podcastUser?.endDateTrialTime
            ) {
              await this.props.dispatch(updateIsFirstLogin(false));
            }

            if (currentPath === '/freetrial') {
              return;
            }

            if (!isSubscriptionActive && !this.props.isFirstLogin) {
              this.props.history.push(defaultRoute());
            }

            if (
              authUser.userStatus === undefined ||
              authUser.subscriptionType === undefined
            ) {
              if (!authCondition(authUser, isPersonalPodcastOwner)) {
                this.props.history.push(defaultRoute());
              }
            } else {
              if (!authCondition(authUser, isPersonalPodcastOwner)) {
                this.props.history.push(
                  defaultRoute(authUser.userStatus, authUser.subscriptionType)
                );
              }
            }
          } catch (error) {
            console.error(error);
          }
        } else if (!authCondition(authUser)) {
          this.props.history.push('/');
        }
      });
    }

    componentWillUnmount() {
      this.listener();
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {({ authUser }) => (authUser ? <Component {...this.props} /> : null)}
        </AuthUserContext.Consumer>
      );
    }
  }

  const mapStateToProps = (store) => {
    return {
      mysubscriptions: store.user.mysubscriptions,
      podcastUser: store.user.podcastUser,
      isFirstLogin: store.user.isFirstLogin
    };
  };

  return withRouter(connect(mapStateToProps)(WithAuthorization));
};

export default withAuthorization;
